import routes from '@/pages/public/routes';

interface GetPublicMicroLearningUrlParams {
  appUrl?: string | null;
  name?: string | null;
  publicId?: string | null;
}

export default function getPublicMicroLearningUrl({
  appUrl,
  name,
  publicId,
}: GetPublicMicroLearningUrlParams) {
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : appUrl;

  if (!baseUrl || !name || !publicId) {
    return null;
  }

  return new URL(routes.PublicMicroLearning(name, publicId), baseUrl).href;
}
